import { Tender} from 'src/app/models/Tender.class'

export class SelectTenderEventProps{

    constructor(){
        this.SelectedTender ={TenderId:0,Title:'',MolsaTenderNumber:'',Files:[]};
        this.EventType='';
    }

    SelectedTender:Tender;
    EventType:string;
}